import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import GetMinimumLogLevelResponse from '../models/get-minimum-log-level-response';

const configurationBaseUrl = '/api/v1/Configuration';

enum ConfigurationQueryPaths {
  GetMinimumLogLevel = 'GetMinimumLogLevel',
}

const getMinimumLogLevel = async (axiosInstance: AxiosInstance): Promise<GetMinimumLogLevelResponse> => {
  const response = await axiosInstance.get(`${configurationBaseUrl}/${ConfigurationQueryPaths.GetMinimumLogLevel}`);
  return response.data;
};

export const useLazyGetMinimumLogLevel = () => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [ConfigurationQueryPaths.GetMinimumLogLevel],
    queryFn: () => getMinimumLogLevel(authenticatedInstance),
    enabled: false,
  });
};
